import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Redirect, useLocation } from 'react-router-dom';
import './App.css';
import GoogleFontLoader from 'react-google-font-loader';
import { geolocated } from "react-geolocated";

import { AuthUserContext, withAuthentication } from './components/Session';

import Navigation from './pages_traffic/Navigation';
import Footer from './pages/Footer';
import ThankYou from './pages/ThankYou';

import carSearch from './pages_traffic/carSearch';
import carAdd from './pages_traffic/carAdd';
import carList from './pages_traffic/carList';
import carListForAdmin from './pages_traffic/carListForAdmin';
import carListForTowing from './pages_traffic/carListForTowing';
import carListForParking from './pages_traffic/carListForParking';
import carDemoReport from './pages_traffic/carDemoReport';
{/* <style>
@import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,400;0,800;1,100;1,500&display=swap');
</style> */}
        
const App = (props) => (
  
    <Router>
      <GoogleFontLoader
      fonts={[ { font: 'Sarabun', weights: [400, '400'], }]} subsets />
      
      <div className="App" style={{fontFamily: 'Sarabun, sans-serif'}}>
        <Navigation />
        <div style={{marginTop:"80px"}}></div>
        <AuthUserContext.Consumer>
          { authUser => authUser && authUser.roles && !!authUser.roles["ADMIN"] && (
              <> <hr/> {JSON.stringify(authUser)} <hr/> </>
          )}
        </AuthUserContext.Consumer>
        <Route exact path="/carSearch" component={carSearch} />
        <Route exact path="/carAdd" component={carAdd} />
        <Route exact path="/carList" component={carList} />
        <Route exact path="/carListForAdmin" component={carListForAdmin} />
        <Route exact path="/carListForTowing" component={carListForTowing} />
        <Route exact path="/carListForParking" component={carListForParking} />
        <Route exact path="/carListForTowing/:id" component={carListForTowing} />
        <Route exact path="/carListForParking/:id" component={carListForParking} />
        <Route exact path="/carDemoReport" component={carDemoReport} />
        
        {/* {
         !this.props.isGeolocationAvailable ? (
            <div>Your browser does not support Geolocation</div>
        ) : !this.props.isGeolocationEnabled ? (
            <div>Geolocation is not enabled</div>
        ) : this.props.coords ? (
            <table>
                <tbody>
                    <tr>
                        <td>latitude</td>
                        <td>{this.props.coords.latitude}</td>
                    </tr>
                    <tr>
                        <td>longitude</td>
                        <td>{this.props.coords.longitude}</td>
                    </tr>
                    <tr>
                        <td>altitude</td>
                        <td>{this.props.coords.altitude}</td>
                    </tr>
                    <tr>
                        <td>heading</td>
                        <td>{this.props.coords.heading}</td>
                    </tr>
                    <tr>
                        <td>speed</td>
                        <td>{this.props.coords.speed}</td>
                    </tr>
                </tbody>
            </table>
        ) : (
            <div>Getting the location data&hellip; </div>
        )
    } */}
        {/* <Footer/> */}
      </div>
    </Router>
)
export default withAuthentication(App);




